import { memo } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import styles from './Products.module.scss';
import { SearchStateProps } from '@/redux/store/reducer/searchReducer';
import Cards from './cards/Cards';
import Pagination from './pagination/Pagination';
import SearchFooter from './searchFooter/SearchFooter';
import CardsSkeleton from './cards/cardsSkeleton/CardsSkeleton';
import Box from '@/components/UI/box/Box';
import BundleBanner from './bundleBanner/BundleBanner';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
import { SearchDataProps } from '@/components/search/_types/searchDataType';
import FilterSorting from './filterSorting/FilterSorting';
const EmptyList = dynamic(() => import('./emptyList/EmptyList'), {
  ssr: false
});
interface ProductsProps {
  perPage: number;
  data: SearchDataProps;
  loading: boolean;
  firstData: SearchStateProps;
  isBot: boolean;
}
const Products = ({
  perPage,
  data,
  loading,
  firstData,
  isBot
}: ProductsProps) => {
  const router = useRouter();
  const isWhiteLabel = useIsWhiteLabel();
  return <>
      {data && data.list?.length === 0 || firstData.list?.length === 0 ? <>
          <FilterSorting data={data} />
          <EmptyList />
        </> : <Box className={styles['products-main-container']} component={'main'}>
          <Box className={styles['products-container']}>
            {(loading || !data?.list) && !isBot ? <>
                <FilterSorting data={data as SearchDataProps} />
                <CardsSkeleton firstData={firstData} />
              </> : <>
                {data?.discount_motivation?.total_discount_amount && !isWhiteLabel && <BundleBanner data={data.discount_motivation} />}
                <FilterSorting data={data} />
                <Cards page={Number(router.query?.page) || 1} perPage={perPage} data={data?.list} searchId={data?.search_id} />
                <Pagination perPage={perPage} data={data} />
              </>}
            {data?.region_data && !isWhiteLabel && <SearchFooter url={router.asPath as string} region_data={data?.region_data} />}
          </Box>
        </Box>}
    </>;
};
// }

export default memo(Products);